import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import {
    FaUser,
    FaShoppingCart,
    FaSearch,
    FaSignOutAlt,
    FaBars,
    FaTimes,
    FaHome,
    FaPoll,
    FaGift,
    FaUsers,
    FaEnvelope,
    FaSignInAlt,
} from "react-icons/fa";
import "../styles/Navbar.css";

const Navbar = () => {
    const { cartItems } = useCart();
    const { user, logout } = useAuth();
    const [query, setQuery] = useState("");
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate("/");
    };

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const closeMenu = () => setMenuOpen(false);

    const handleSearch = () => {
        if (query.trim()) {
            navigate(`/buscar?q=${encodeURIComponent(query)}`);
            setQuery("");
        }
    };

    return (
        <>
            <nav className="navbar">
                <button className="hamburger" onClick={toggleMenu}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>

                <div className="navbar-logo-container">
                    <Link to="/">
                        <img src="/assets/logobyr.png" alt="Logo" className="navbar-logo" />
                    </Link>
                </div>

                <div className="navbar-center-links">
                    <Link to="/">Home</Link>
                    <Link to="/loyalty">Loyalty</Link>                               
                    <Link to="/">Encuestas</Link>
                    <Link to="/">Contacto</Link>
                </div>

                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Buscar..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <FaSearch className="icon" onClick={handleSearch} />
                </div>
                <div className="navbar-right">

                    <Link to="/perfil">
                        <FaUser className="navbar-icon" />
                    </Link>
                    <Link to="/cart" className="navbar-cart">
                        <FaShoppingCart className="navbar-icon" />
                        {cartItems.length > 0 && (
                            <span className="cart-badge">{cartItems.length}</span>
                        )}
                    </Link>
                    {user && (
                        <button className="logout-icon-btn" onClick={handleLogout}>
                            <FaSignOutAlt className="navbar-icon" />
                        </button>
                    )}
                </div>
            </nav>

            {/* Overlay oscuro */}
            {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

            {/* Menú lateral */}
            <div className={`sidebar-menu ${menuOpen ? "open" : ""}`}>
                <Link to="/" onClick={closeMenu}>
                    <FaHome className="menu-icon" /> Home
                </Link>
                <Link to="/buscar" onClick={closeMenu}>
                    <FaSearch className="menu-icon" /> Buscar
                </Link>
                <Link to="/loyalty" onClick={closeMenu}>
                    <FaGift className="menu-icon" /> Loyalty
                </Link>                
                <a href="#categories" onClick={closeMenu}>
                    <FaPoll className="menu-icon" /> Encuestas
                </a>
                <a href="#contact" onClick={closeMenu}>
                    <FaEnvelope className="menu-icon" /> Contacto
                </a>
                {!user && (
                    <Link to="/login" onClick={closeMenu}>
                        <FaSignInAlt className="menu-icon" /> Iniciar sesión
                    </Link>
                )}
            </div>
        </>
    );
};

export default Navbar;
